
<!--start section header-->
 
<header class="head">
   <div class="cover">
       <div class="container d-flex justify-content-center align-items-center pt-5">
        <div>
            <h2 class="pt-5">
                Pipeline
            </h2>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li (click) = change() class="breadcrumb-item">
                      <a>Home</a>
                    </li>
                  <li class="breadcrumb-item active" aria-current="page">Pipeline</li>
                </ol>
            </nav>
        </div>

       </div>
   </div>

</header>

<!--end section header-->

<!--start section Drugs-->

<section class="py-5 container drugs">
    <div class="row pt-5">


        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/w.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Research & Preclinical</h5>
                  <p class="card-text">Doner meatloaf pork loin tenderloin <br>
                            alcatra ground round shankle cupim <br>
                            spare ribs filet mignon venison.
                 </p>
                  <button class="btn btn-outline-primary">Learn More</button>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/21.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Starting Phase</h5>
                  <p class="card-text">Pastrami sirloin corned beef pig turkey <br>
                     porchetta spare ribs. Landjaeger chicken <br>
                      doner jerky strip steak meatball.
                  </p>
                  <button class="btn btn-outline-primary">Learn More</button>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/m.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Medium Phase</h5>
                  <p class="card-text">Jerky tri-tip venison doner swine turkey <br>
                     landjaeger corned beef drumstick. Jerky <br>
                      meatloaf pork loin strip steak.
                  </p>
                  <button class="btn btn-outline-primary">Learn More</button>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/22.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Finishing Phase</h5>
                  <p class="card-text">Cow ham hock sirloin, cupim tongue <br>
                     swine picanha meatloaf alcatra capicola <br>
                      venison kevin bacon meatball ham.
                  </p>
                  <button class="btn btn-outline-primary">Learn More</button>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/20.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">After Drug Approval</h5>
                  <p class="card-text">Fatback t-bone flank bacon shank short <br>
                     ribs shankle. Shoulder ribeye pork belly, <br>
                      bresaola pork chop pig ball tip.
                 </p>
                  <button class="btn btn-outline-primary">Learn More</button>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/19.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Drugs Production</h5>
                  <p class="card-text">Ham hock andouille meatloaf bresaola <br>
                     turducken. Pork loin capicola short ribs, <br>
                      pig pork ground round chuck tail.
                  </p>
                  <button class="btn btn-outline-primary">Learn More</button>
                </div>
              </div>
        </div>

    </div>
</section>

<!--end section Drugs-->